<template>
    <v-dialog v-model="obModal.abrirModal" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> <span class="white--text headline"
                    v-html="obModal.titulo"></span></v-card-title>
            <v-card-text>
                <v-form ref="form_ingreso_documento" :lazy-validation="false">
                    <v-container grid-list-sm>
                        <v-row dense>
                            <v-col cols="12">
                                <span class="headline" v-html="'Datos de Póliza'"></span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Contratante" color="textbox" v-model="obModal.contratante"  outlined dense disabled/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Asegurado" color="textbox" v-model="obModal.asegurado" outlined dense disabled/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Fecha Desde" color="textbox" v-model="obModal.fechaDesdePoliza"  outlined dense disabled/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Fecha hasta" color="textbox" v-model="obModal.fechaHastaPoliza" outlined dense disabled/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <span class="headline" v-html="'Datos de Certificado'"></span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Tipo de Anexo" color="textbox" v-model="obModal.tipoAnexo"  outlined dense disabled/>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="N° Solicitud" color="textbox" v-model="obModal.nroSolicitud" outlined dense disabled/>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Fecha Desde" color="textbox" v-model="obModal.fechaDesde"  outlined dense disabled/>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Fecha hasta" color="textbox" v-model="obModal.fechaHasta" outlined dense disabled/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12">
                                <span v-if="_.toNumber(listParametros.id_tipo_solicitud_inclusion) == _.toNumber(obModal.idTipoSolicitud)" class="headline" v-html="'Datos de Inclusión'"></span>
                                <span v-if="_.toNumber(listParametros.id_tipo_solicitud_cancelacion) == _.toNumber(obModal.idTipoSolicitud)" class="headline" v-html="'Datos de Exclusión'"></span>
                                <span v-else class="headline" v-html="'Datos de Cancelación'"></span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-textarea filled dense color="textbox" label="Descripción" v-model="obModal.descripcion" :value="obModal.descripcion"  :disabled="disabledText"/>
                            </v-col>
                        </v-row>
                        <v-form ref="form_modal">
                            <v-row dense>
                                    <v-col cols="12" sm="3">
                                        <v-text-field label="Valor Asegurado" color="textbox" v-model="obModal.valor" :rules="_.concat(requeridoRegla,decimal)" 
                                                    outlined dense/>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field label="Prima Neta" color="textbox" v-model="obModal.primaNeta" :rules="_.concat(requeridoRegla,decimal)" 
                                                    outlined dense />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-file-input label="Cargar Documento(Anexo)" color="textbox" v-model="obModal.nameFile" 
                                                      :rules="_.concat(requeridoRegla,rules)" @change="loadFile"
                                                      accept="application/pdf" prepend-icon="attach_file" outlined dense></v-file-input>
                                    </v-col>
                            </v-row>
                        </v-form>
                        <v-row>
                            <v-col class="text-right">
                                <v-btn outlined rounded class="mr-1" :disabled="disabled" @click="clear">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" :disabled="disabled" @click="guardar">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'IngresoDocumentoManualComponent',
        inject:['insertarActualizar','reset'],
        props:{
            objetoModal:{
                type: Object,
                default:{}
            },
            listParametros:{
                type: Object,
                default:{}
            },
            active:{
                type:Boolean,
                default:false
            }
        },
        data: () =>({
            rules:[
                value => !value || value.size < 5000000 || 'El tamaño de la foto debe ser inferior a 5 MB.',
            ],
            disabled: false,
            disabledText: true,
            obModal:{
                abrirModal: false,
                titulo: ''
            }
        }),
        watch:{
            active(val){
                this.obModal.titulo = '';
                if(val){
                    this.obModal = this.objetoModal;
                    this.obModal.titulo = 'Ingreso de Documento Manual';
                    this.disabledText = _.size(_.get(this.obModal,'descripcion','')) > 0 ? true : false;
                }
            }
        },
        methods:{
            loadFile(){
                this.disabled = true;
                var reader = new FileReader();
                    reader.readAsDataURL(this.obModal.nameFile);
                    reader.onload = () => {
                        this.$set(this.obModal,'base64Doc',reader.result);
                        this.disabled = false;
                    };
            },
            guardar(){
                try {
                    this.disabled = true;
                    if(!this.$refs.form_modal.validate()) throw mensajeEstandar.corregirInformacion;                  
                    // if((!_.isUndefined(this.obModal.base64Doc)) && (!_.isNull(this.obModal.base64Doc))) throw 'Error al leer el documento seleccionado.';                    
                        var keys = [
                                        'opcion','idCertificado','idPoliza','idSolicitud','idInclusion',
                                        'idInclusionAccesorio','idExclusion','valor','primaNeta','idPrima',
                                        'idProducto','descripcion','idTipoSolicitud','idSeguro','base64Doc',
                                        'idCancelacion','poliza'
                                    ];

                        this.obModal.opcion = _.isNull(_.get(this.obModal,'idPrima',null)) ? 'I' : 'U';
                        this.insertarActualizar(_.pick(_.cloneDeep(this.obModal),keys))
                            .then((r)=>{
                                if(!r) throw 'Error';
                                    this.obModal = { abrirModal: false, titulo: ''};
                                    this.reset();
                            })
                            .catch((e)=>{
                                this.disabled = false;
                                mensajesAlerta(e,'E');
                            });
                } catch (e) {
                    mensajesAlerta(e,'I');
                    this.disabled = false;
                }
            },
            clear(){
                this.obModal = { abrirModal: false, titulo: '' };
                this.disabled = false;
                this.reset();
            }
        }
    }
</script>